import { createRouter, createWebHistory } from 'vue-router'
import routes from '@/routes'
import { useObuGlobalStore } from '@/pinia/ObuGlobalStore'

const router = createRouter({
  history: createWebHistory(),
  routes
})

async function guardRoute (to, from, next) {
  const token = await sessionStorage.getItem('token')
  const globalStore = useObuGlobalStore()
  if (token !== null) {
    next()
  } else {
    globalStore.setLoginRedirect(to.fullPath)
    next('/auth/login')
  }
}

router.beforeEach(async (to, from, next) => {
  const needAuth = (to.meta.auth === undefined) ? true : to.meta.auth
  if (needAuth) {
    guardRoute(to, from, next)
  } else {
    next()
  }
})

export default router
